import { render, staticRenderFns } from "./AS_ViewBill.vue?vue&type=template&id=2fe884a2&scoped=true&"
import script from "./AS_ViewBill.vue?vue&type=script&lang=js&"
export * from "./AS_ViewBill.vue?vue&type=script&lang=js&"
import style0 from "./AS_ViewBill.vue?vue&type=style&index=0&id=2fe884a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe884a2",
  null
  
)

export default component.exports